import { Injectable } from '@angular/core';
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';
import { UserSettings } from '@user/model/user-settings';
import { ProjectModel } from '@project/model/project.model';
import { ProServeProjectImportProcessor } from '@project/components/import-export/processor/pro-serve-project-import.processor';

@Injectable({providedIn: 'root'})
export class ProServeProjectNavigationService {

  constructor(private userSettings: UserSettings,
              private projectModel: ProjectModel,
              private proServeProjectImportProcessor: ProServeProjectImportProcessor) {

  }

  public async startImportProServeProcess(currentProjectGroup: ProjectGroupVO, document: Document): Promise<void> {
    const selectedNode: ProjectGroupVO = currentProjectGroup;
    let selectedGroupId: number = NaN;
    if (selectedNode.groupType !== -1) {
      selectedGroupId = selectedNode.id;
    }
    this.userSettings.setUserSettingValue("lastSelectedProjectGroupId", selectedGroupId);
    this.userSettings.saveUserSettings();
    await this.startImportProServe(document, selectedNode);
  }

  private async startImportProServe(document: Document, projectGroup: ProjectGroupVO) {
    if (this.projectModel.user.hasPermission("IMPORT_PROSERVE_PROJECTS")) {
      await this.proServeProjectImportProcessor.importProServeProject(document.childNodes[0], projectGroup);
    }
  }
}
